import type { LucideIcon } from 'lucide-react';
import { Button } from './Button';
import { Icon } from './Icon';

export function EmptyStateComponent({
	icon,
	title,
	description,
	action,
}: {
	icon?: LucideIcon;
	title?: string;
	description?: string;
	action?: { label: string; onClick: () => void };
}) {
	return (
		<div className="flex h-full flex-col items-center justify-center text-center">
			{icon && <Icon icon={icon} className="mb-8 size-24 opacity-60" />}
			{title && icon && <h2 className="text-2xl font-bold">{title}</h2>}
			{title && !icon && <h2 className="text-6xl font-bold">{title}</h2>}
			{description && <p className="opacity-80">{description}</p>}
			{action && (
				<Button onClick={action.onClick} className="mt-4">
					{action.label}
				</Button>
			)}
		</div>
	);
}
